export default __webpack_public_path__ + "static/media/harvest.a9f758d0.svg";